import { useCallback, useState } from "react"
import { useTranslation } from "react-i18next"
import { Stack, Typography } from "@mui/material"

import Spinner from "../Spinner"
import OTPCodeField from "./OTPCodeField"

interface TwoFactorVerificationProps {
  verify: (value: string) => Promise<void>
  isVerifying: boolean
  otpCode: string
  handleSwitchVerification: () => void
}

const TwoFactorVerification = ({
  verify,
  isVerifying,
  otpCode,
  handleSwitchVerification,
}: TwoFactorVerificationProps) => {
  const { t } = useTranslation()
  const [otp, setOtp] = useState("")

  const handleChange = useCallback(
    (value: string) => {
      setOtp(value)
    },
    [setOtp],
  )

  const handleComplete = async (value: string) => {
    try {
      await verify(value)
    } catch {
      // nothing
    }
    handleChange("")
  }

  return (
    <>
      <Typography
        id="otp-verifier-description"
        variant="h6"
        component={"h6"}
        align="center"
        mb={3}
      >
        {t("auth.ENTER_AUTH_CODE")}
      </Typography>
      <Stack direction="row" justifyContent={"center"} alignItems={"center"} gap={4}>
        {isVerifying ? (
          <Spinner />
        ) : (
          <OTPCodeField value={otp} onChange={handleChange} onComplete={handleComplete} />
        )}
      </Stack>
      {otpCode && (
        <Stack justifyContent={"center"} alignItems={"center"} mt={5} gap={1}>
          <Typography>{t("auth.LOST_OTP")}</Typography>
          <Typography
            color="primary"
            sx={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={handleSwitchVerification}
          >
            {t("auth.USE_RECOVERY_CODES")}
          </Typography>
        </Stack>
      )}
    </>
  )
}

export default TwoFactorVerification
